/**
 * ParticularOrderOutputDto
 * Auto-generated from C# model
 * Maps properties to TypeScript types
 */

import { ParticularOrderStatus } from './enumParticularOrderStatus';
import { PaymentLocation } from './enumPaymentLocation';
import { WaypointDto } from './waypointDto';

export interface ParticularOrderOutputDto {
  id: number;
  originAddress: string;
  originLatitude: number | null;
  originLongitude: number | null;
  destinationAddress: string;
  destinationLatitude: number | null;
  destinationLongitude: number | null;
  recipientName: string;
  pickupTimeRange: string;
  deliveryTimeRange: string;
  pickupPhone: string;
  deliveryPhone: string;
  shippingDetails: string;
  whereToPay: PaymentLocation;
  observations: string;
  createdAt: string;
  distanceKm: number | null;
  calculatedCost: number | null;
  finalCost: number | null;
  finalCostWithIVA: number | null;
  updatedAt: string | null;
  status: ParticularOrderStatus;
  waypoints: WaypointDto[];
}
